/// <reference path="stylegallery.module.ts" />

module Meevo.Plugins.StyleGallery {
    "use strict";

    // class definition
    interface IStyleGallery {
        items: Array<any>;
    }
    class StyleGalleryController implements IStyleGallery {
        items: Array<any>;
        count: number;
        myControllerValue: string = 'Hello styles';

        constructor() {
            var vm = this;

            vm.count = 0;

            //example json------------------
            vm.items = [
                {
                    text: "test",
                    selected: false,
                    contextKey: "something"
                },
                {
                    text: "test2",
                    contextKey: "ething2"
                },
                {
                    text: "test3",
                    selected: false,
                    contextKey: "something3"
                },
                {
                    text: "test4",
                    selected: false,
                    contextKey: "something4"
                },
                {
                    text: "test5",
                    selected: false,
                    contextKey: "something5"
                },
                {
                    text: "Something",
                    selected: false,
                    contextKey: "something5"
                },
                {
                    text: "something",
                    selected: false,
                    contextKey: "something5"
                },
                {
                    text: "stuff",
                    selected: false,
                    contextKey: "something5"
                },
                {
                    text: "foo",
                    selected: false,
                    contextKey: "something5"
                },
                {
                    text: "fooey",
                    selected: false,
                    contextKey: "something5"
                }
            ]
            //------------------------------

        }

        test() {
            this.myControllerValue = 'test';
        }        
    }

    // controller registration with module
    angular.module("meevo.plugins.styleGallery")
        .controller("meevo.plugins.styleGallery.StyleGalleryController",
        StyleGalleryController);
}
